export default "__VITE_ASSET__C4Dm4KSg__"